import React from 'react';

import { describeFreshness } from '../../lib/dossierTimeline';

interface FreshnessBadgeProps {
  timestamp: number | null | undefined;
  compact?: boolean;
}

const TONE_STYLES = {
  fresh: 'border-emerald-500/30 bg-emerald-500/10 text-emerald-500',
  recent: 'border-blue-500/30 bg-blue-500/10 text-blue-500',
  aging: 'border-amber-500/30 bg-amber-500/10 text-amber-500',
  stale: 'border-red-500/30 bg-red-500/10 text-red-500',
  unknown: 'border-cream-300 bg-cream-100 text-navy-500 dark:border-navy-600 dark:bg-navy-800/50 dark:text-navy-300',
} as const;

export default function FreshnessBadge({ timestamp, compact = false }: FreshnessBadgeProps) {
  const freshness = describeFreshness(timestamp);
  const exactTimestamp = Number.isFinite(timestamp)
    ? new Date(Number(timestamp)).toLocaleString([], {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : 'Timestamp unavailable';

  return (
    <div className={`rounded-xl border px-3 py-2 ${compact ? 'min-w-[150px]' : ''} ${TONE_STYLES[freshness.tone]}`}>
      <p className="text-[9px] font-black uppercase tracking-widest">{freshness.label}</p>
      <p className="mt-1 text-[11px] font-semibold text-current/90">{exactTimestamp}</p>
      {!compact && <p className="mt-2 text-[11px] leading-relaxed text-current/80">{freshness.detail}</p>}
    </div>
  );
}
